import apiClient from '../index'

// Background bell polling — a failed refresh just leaves the list as it is, so it must not
// raise a toast. The interceptor already reports failures for the user-triggered calls below.
export const getUserNotifications = ({ limit = 20, unread = true } = {}) =>
  apiClient.get('notification', {
    params: { limit, unread },
    suppressErrorNotification: true,
  })

export const readUserNotification = () => apiClient.post('notification/mark-all-read')

export const readNotification = (notificationId) =>
  apiClient.patch(`notification/${notificationId}/read`)

export const getUnreadNotificationCount = () =>
  apiClient.get('notification/unread-count', { suppressErrorNotification: true })
